import React from "react";
import { IconT } from "types/utils";

const BulletIcon = ({ height = 14, width = 14, fill = "none", stroke = "#0070F4" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14" fill={fill}>
      <circle cx="7" cy="7" r="6" stroke={stroke} strokeWidth="2" />
    </svg>
  );
};

export default BulletIcon;
